import React from "react";
import Navbar from "../../layout/Navbar";
import Footer from "../../layout/Footer"; // Added Footer for consistency with About.js
import FireBricks from "../../assets/Our Products/refractory-Fire-bricks.jpeg";
import CastableMonolithics from "../../assets/Our Products/Castable-monolithics.jpeg";
import CeramicFiber from "../../assets/Our Products/INSULATION- CERAMIC-FIBER.jpeg";
import RefractoryCement from "../../assets/Our Products/REFRACTORY-CEMENT.jpg";
import RefractoryMortar from "../../assets/Our Products/refractory-mortar.jpg";
import Boiler from "../../assets/Our Products/BOILER-BED-MATERIALS-GROG.jpg";
import Bauxite from "../../assets/Our Products/BAUXITE.jpg";
import PreCastBlocks from "../../assets/Our Products/PRE-CAST-PRE-FIRE-BLOCKS.jpg";
import { Link } from "react-router-dom";

const products = [
    {
        name: "Refractory Fire Bricks",
        image: FireBricks,
        path: "/products/refractory_bricks"  // ← जोड़ें
    },
    {
        name: "Castable / Monolithics",
        image: CastableMonolithics,
        path: "/products/castable-monolithics"
    },
    {
        name: "Refractory Mortar",
        image: RefractoryMortar,
        path: "/products/mortar"
    },
    {
        name: "Insulation / Ceramic Fiber",
        image: CeramicFiber,
        path: "/products/insulation-fiber-blanket"
    },
    {
        name: "Refractory Cement",
        image: RefractoryCement,
        path: "/products/refractory-cement"
    },
    {
        name: "Boiler Bed Materials / Grog",
        image: Boiler,
        path: "/products/bed-materials"
    },
    {
        name: "Bauxite",
        image: Bauxite,
        path: "/products/bauxite"
    },
    {
        name: "Pre Cast Pre Fire Blocks",
        image: PreCastBlocks,
        path: "/products/precast-prefire"
    },
];

const Product = () => {
    return (
        <div className="min-h-screen bg-gray-50">
            <Navbar />
            {/* Hero Section */}
            <section className="relative h-[50vh] sm:h-[60vh] flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <img
                        src={products[0].image} // Using first product image as hero background
                        alt="Product Background"
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 via-slate-900/60 to-transparent"></div>
                    <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-transparent to-slate-900/40"></div>
                </div>
                <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h1 className="text-3xl sm:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6 animate-fadeInUp">
                        Our <span className="text-orange-500">Products</span>
                    </h1>
                    <p className="text-base sm:text-lg lg:text-xl text-gray-300 mb-6 sm:mb-8 max-w-xl sm:max-w-2xl lg:max-w-3xl mx-auto animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
                        Discover our range of high-quality refractory products for industrial applications
                    </p>
                </div>
            </section>

            {/* Products Section */}
            <section className="py-12 sm:py-16 lg:py-20 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-8 sm:mb-12">
                        Explore Our <span className="text-orange-500">Product Range</span>
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
                        {products.map((product, index) => (
                            <div
                                key={index}
                                className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-transform transform hover:-translate-y-2 overflow-hidden animate-fadeInUp"
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <div className="w-full h-56 flex items-center justify-center bg-white">
                                    <img
                                        src={product.image}
                                        alt={product.name}
                                        className="max-h-full max-w-full object-contain"
                                    />
                                </div>
                                <div className="p-6">
                                    <h3 className="text-lg sm:text-xl lg:text-2xl font-semibold text-gray-800 mb-4">
                                        {product.name}
                                    </h3>
                                    <Link
                                        to={product.path}
                                        className="inline-block px-4 py-2 bg-gradient-to-r from-yellow-500 to-orange-500 text-white rounded-lg hover:from-yellow-600 hover:to-orange-600 transition-all transform hover:scale-105"
                                    >
                                        Learn More
                                    </Link>
                                </div>
                            </div>

                        ))}
                    </div>
                </div>
            </section>

            <style jsx>{`
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                .animate-fadeInUp {
                    animation: fadeInUp 0.8s ease-out forwards;
                    opacity: 0;
                }
            `}</style>
            <Footer />
        </div>
    );
};

export default Product;